import classnames from 'classnames';

import { labelStyle, optionWrapperStyle, radioStyle } from './AdditionalFields.css';

interface RadioOptionProps {
  name: string;
  value: string;
  label: string;
  required?: boolean;
}

const RadioOption = ({ name, value, label, required }: RadioOptionProps) => (
  <div>
    <label className={classnames(optionWrapperStyle, labelStyle)}>
      <input name={name} value={value} type="radio" defaultChecked={false} className={radioStyle} required={required} />
      <span>{label}</span>
    </label>
  </div>
);

export default RadioOption;
